/**
 * @file 都道府県のセレクトボックス又は、郵便番号の値を監視
 */
'use strict'

/**
 * @classname ChangeSearchItemPrefecture
 * @classdesc 都道府県のセレクトボックス又は、郵便番号の値を監視
 * 北海道：HOKKAIDO = 1;
 * 東北： TOHOKU = 2;
 * 関東： KANTO = 3;
 * 北陸： HOKURIKU = 4;
 * 甲信越： KOSHINETSU = 5;
 * 東海： TOKAI = 6;
 * 関西： KANSAI = 7;
 * 中国： CHUGOKU = 8;
 * 四国： SHIKOKU = 9;
 * 九州： KYUSHU = 10;
 * 沖縄： OKINAWA = 11;
 */
export default class ChangeSearchItemPrefecture {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-toggle-password')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._$searchItemPrefecture = $('.input-select-search-item-prefecture')
		this._$searchItemArea = $('.input-select-search-item-area')
		this._$searchItemRecommendSpot = $('.input-select-search-item-recommend-spot')
		// 郵便番号JSの変更を拾うためにblurしてる
		this._$e.on('blur', () => this.onChange())
		this._$searchItemPrefecture.on('change', () => this.onChange())
		this._isAreaChange = true;
		if(this._$searchItemRecommendSpot.val() === '') {
			if(this._$searchItemArea.val() !== ''){
				this._isAreaChange = false;
			}
			this.onChange()
		}
	}

	/**
	 * onChangeのコールバック
	 *
	 * @memberof ChangeSearchItemPrefecture
	 * @description 郵便番号の変更があった時、エリアとおすすめスポットの内容を変更する
	 * @return {undefined}
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`)

		let prefectureCode
		// 案件作成
		// 郵便番号jsが1桁の場合は、頭に0をつける
		if ($('.p-region-id').length > 0 && $('.p-region-id').val() !== '') {
			prefectureCode = $('.p-region-id').val()
			if (prefectureCode.length === 1) {
				prefectureCode = '0' + prefectureCode;
			}
			this._$searchItemPrefecture.val(prefectureCode)
			$('.p-region-id').val('')
		// 施設・地域特集、体験談
		} else {
			prefectureCode = this._$searchItemPrefecture.val()
		}

		let area = ''
		if (prefectureCode == '01') {
			area = '1'
		} else if (['02', '03', '04', '05', '06', '07'].includes(prefectureCode)) {
			area = '2'
		} else if (['08', '09', '10', '11', '12', '13', '14'].includes(prefectureCode)) {
			area = '3'
		} else if (['16', '17', '18'].includes(prefectureCode)) {
			area = '4'
		} else if (['15', '19', '20'].includes(prefectureCode)) {
			area = '5'
		} else if (['21', '22', '23', '24'].includes(prefectureCode)) {
			area = '6'
		} else if (['25', '26', '27', '28', '29', '30'].includes(prefectureCode)) {
			area = '7'
		} else if (['31', '32', '33', '34', '35'].includes(prefectureCode)) {
			area = '8'
		} else if (['36', '37', '38', '39'].includes(prefectureCode)) {
			area = '9'
		} else if (['40', '41', '42', '43', '44', '45', '46'].includes(prefectureCode)) {
			area = '10'
		} else if (prefectureCode == '47') {
			area = '11'
		}
		if(this._isAreaChange){
			this._$searchItemArea.val(area)
		}else {
			this._isAreaChange = true;
		}
		this.changeRecommendSport(area)
	}

	/**
	 * changeRecommendSportのコールバック
	 *
	 * @memberof ChangeSearchItemPrefecture
	 * @description おすすめスポットを書き換える
	 * @return {undefined}
	 */
	changeRecommendSport(area) {
		console.log(`${this.constructor.name}.changeRecommendSport`, area)
		let spotArr = []
		this._$searchItemRecommendSpot.children().remove()
		this._$searchItemRecommendSpot.append($(`<option value="">選択してください</option>`))
		if (area === '1') {
			spotArr = ['札幌', 'ニセコ', 'トマム', 'キロロ', 'ルスツ', '知床', '利尻島', '礼文島', '函館', '富良野', '洞爺湖温泉', '登別温泉']
		} else if (area === '2') {
			spotArr = ['奥入瀬渓流', '秋保温泉', '蔵王温泉', '銀山温泉', '磐梯', '安比高原', '鳴子温泉']
		} else if (area === '3') {
			spotArr = ['東京23区', '箱根', '湯河原', '草津温泉', '江の島', '日光', '那須', '四万温泉', '水上温泉', '伊香保温泉', '鬼怒川温泉', '八丈島']
		} else if (area === '4') {
			spotArr = ['金沢', '和倉温泉', '加賀温泉郷', '粟津温泉', 'あわら温泉', '宇奈月温泉', '立山']
		} else if (area === '5') {
			spotArr = [, '軽井沢', '白馬', '上高地', '渋・湯田中温泉', '蓼科', '白骨温泉', '野沢温泉', '河口湖', '湯沢温泉', '佐渡島']
		} else if (area === '6') {
			spotArr = [, '熱海', '飛騨高山', '下呂温泉', '奥飛騨温泉', '初島', '鳥羽', '伊勢志摩', '東伊豆', '西伊豆']
		} else if (area === '7') {
			spotArr = [, '京都市周辺', '城崎温泉', '雄琴温泉・琵琶湖', '有馬温泉', '淡路島', '白浜海岸', 'ハチ高原']
		} else if (area === '8') {
			spotArr = [, '宮島', '皆生温泉', '大山', '三朝温泉', '玉造温泉', 'めがひら']
		} else if (area === '9') {
			spotArr = [, '小豆島・直島', '鳴門温泉']
		} else if (area === '10') {
			spotArr = [, 'ハウステンボス', '屋久島', '奄美大島', '湯布院', '黒川温泉']
		} else if (area === '11') {
			spotArr = ['沖縄本島', '那覇市', '恩納村', '久米島', '石垣島', '西表島', '小浜島', '宮古島']
		}
		spotArr.forEach((el) => {
			this._$searchItemRecommendSpot.append($(`<option value="${el}">${el}</option>`))
		})
	}
}
